import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { useParams, useHistory } from "react-router-dom";
import Swal from "sweetalert2";

const UploadFiles = ({ show, setShow, id, isInvoice,name }) => {
  const token = JSON.parse(localStorage.getItem("user")).token;
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [files, setFiles] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const history = useHistory();

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*,application/pdf", // Adjust accepted file types as needed
    maxFiles: 1,
    maxSize: 1048576, // 1MB in bytes
    onDrop: (acceptedFiles) => {
      setFiles([
        ...acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        ),
      ]);
    },
  });

  const uploadAllFiles = async () => {
    setIsLoading(true);
    const url = isInvoice ? `Invoicing/AttachInvoicePdf/${id}`: `Invoicing/AttachBillPdf/${id}`
    const formData = new FormData();
    files.forEach((file) => {
      formData.append("files", file);
    });
    fetch(`${BASE_URL}/${url}`, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      Allow: "POST",
      body: formData,
    })
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((data) => [statusCode, data]);
        }
      })
      .then((data) => {
        if (data[0] === 200) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: `${name} uploaded successfully`,
          });
          document.getElementById('refreshMasterInvoice').click()
          setShow(false);
          setFiles([]);
        } else if (data[0] === 400 && data[1].message) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: data[1].message,
          });
        } else if (data[0] === 400) {
          let tt = JSON.parse(data[1]);
          for (const [key, value] of Object.entries(tt.errors)) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: value,
            });
          }
        } else if (data[0] === 401) {
          history.push("/error/401");
        } else if (data[0] === 402) {
          Swal.fire({
            title: "Info!",
            text: "You have to subscribe first!",
            icon: "info",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              history.push("/user-profile");
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleRemoveFile = (fileName) => {
    setFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  };

  const renderFilePreview = (file) => (
    <div key={file.name} className="dropzone-item bg-light-secondary p-3 my-3">
      <div className="dropzone-file d-flex align-items-center justify-content-center">
        <div className="dropzone-filename">
          <span>{file.name}</span> ({(file.size / 1024).toFixed(2)} KB)
        </div>
        <div
          className="dropzone-remove"
          onClick={() => handleRemoveFile(file.name)}
        >
          <i className="flaticon2-cross ml-5 cursor-pointer"></i>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Upload {name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body">
            <div className="form-group row">
              <div className="col-lg-9">
                <div className="d-flex">
                  <div
                    {...getRootProps({
                      className: "dropzone dropzone-multi",
                    })}
                  >
                    <input {...getInputProps()} />
                    <div className="dropzone-panel mb-lg-0 mb-2">
                      <Button className="dropzone-select btn btn-light-primary font-weight-bold btn-sm dz-clickable  mr-2">
                        Attach {name}
                      </Button>
                    </div>
                  </div>
                </div>

                <div className="dropzone-items mt-10">
                  {files.map((file) => renderFilePreview(file))}
                </div>
                <span className="form-text text-muted">
                  Max {name} size is 10MB.
                </span>
              </div>
            </div>
            <div className="d-flex  justify-content-end mt-10">
              <Button
                type="button"
                className="btn btn-secondary font-weight-bold btn-sm mr-2"
                onClick={() =>{setShow(false)}}
              >
                Cancel
              </Button>
              <Button
                disabled={files.length === 0}
                type="button"
                className="btn btn-light-success font-weight-bold btn-sm mr-2"
                onClick={uploadAllFiles}
              >
                {isLoading ? "Uploading..." : `Upload ${name}`}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default UploadFiles;
